import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Icon } from '../display/Icon.tsx';
import styles from './StateBlock.module.css';

export interface EmptyStateProps {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly description?: string | undefined;
  /** The one action to start with. */
  readonly action?: ReactNode | undefined;
}

export const EmptyState = ({ icon, title, description, action }: EmptyStateProps) => (
  <div className={styles.block}>
    <span className={styles.badge}>
      <Icon icon={icon} size="lg" />
    </span>
    <h2 className={styles.title}>{title}</h2>
    {description && <p className={styles.description}>{description}</p>}
    {action && <div className={styles.action}>{action}</div>}
  </div>
);
